/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CommitResponseData,
    CommitResponseDataFromJSON,
    CommitResponseDataToJSON,
    CreatePaymentResponseData,
    CreatePaymentResponseDataFromJSON,
    CreatePaymentResponseDataToJSON,
    Payment,
    PaymentFromJSON,
    PaymentToJSON,
} from '../models';

export interface CommitFSCPaymentRequest {
    ocpApimSubscriptionKey: string;
    authorization: string;
    adyenSDKVersion: string;
}

export interface InitiateFSCPaymentRequest {
    ocpApimSubscriptionKey: string;
    authorization: string;
    adyenSDKVersion: string;
    paymentData?: Payment;
}

/**
 * 
 */
export class FCSPApi extends runtime.BaseAPI {

    /**
     */
    async commitFSCPaymentRaw(requestParameters: CommitFSCPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CommitResponseData>> {
        if (requestParameters.ocpApimSubscriptionKey === null || requestParameters.ocpApimSubscriptionKey === undefined) {
            throw new runtime.RequiredError('ocpApimSubscriptionKey','Required parameter requestParameters.ocpApimSubscriptionKey was null or undefined when calling commitFSCPayment.');
        }

        if (requestParameters.authorization === null || requestParameters.authorization === undefined) {
            throw new runtime.RequiredError('authorization','Required parameter requestParameters.authorization was null or undefined when calling commitFSCPayment.');
        }

        if (requestParameters.adyenSDKVersion === null || requestParameters.adyenSDKVersion === undefined) {
            throw new runtime.RequiredError('adyenSDKVersion','Required parameter requestParameters.adyenSDKVersion was null or undefined when calling commitFSCPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.ocpApimSubscriptionKey !== undefined && requestParameters.ocpApimSubscriptionKey !== null) {
            headerParameters['Ocp-Apim-Subscription-Key'] = String(requestParameters.ocpApimSubscriptionKey);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.adyenSDKVersion !== undefined && requestParameters.adyenSDKVersion !== null) {
            headerParameters['Adyen-SDK-Version'] = String(requestParameters.adyenSDKVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/commit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommitResponseDataFromJSON(jsonValue));
    }

    /**
     */
    async commitFSCPayment(requestParameters: CommitFSCPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CommitResponseData> {
        const response = await this.commitFSCPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async initiateFSCPaymentRaw(requestParameters: InitiateFSCPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CreatePaymentResponseData>> {
        if (requestParameters.ocpApimSubscriptionKey === null || requestParameters.ocpApimSubscriptionKey === undefined) {
            throw new runtime.RequiredError('ocpApimSubscriptionKey','Required parameter requestParameters.ocpApimSubscriptionKey was null or undefined when calling initiateFSCPayment.');
        }

        if (requestParameters.authorization === null || requestParameters.authorization === undefined) {
            throw new runtime.RequiredError('authorization','Required parameter requestParameters.authorization was null or undefined when calling initiateFSCPayment.');
        }

        if (requestParameters.adyenSDKVersion === null || requestParameters.adyenSDKVersion === undefined) {
            throw new runtime.RequiredError('adyenSDKVersion','Required parameter requestParameters.adyenSDKVersion was null or undefined when calling initiateFSCPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.ocpApimSubscriptionKey !== undefined && requestParameters.ocpApimSubscriptionKey !== null) {
            headerParameters['Ocp-Apim-Subscription-Key'] = String(requestParameters.ocpApimSubscriptionKey);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.adyenSDKVersion !== undefined && requestParameters.adyenSDKVersion !== null) {
            headerParameters['Adyen-SDK-Version'] = String(requestParameters.adyenSDKVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/initiate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentToJSON(requestParameters.paymentData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePaymentResponseDataFromJSON(jsonValue));
    }

    /**
     */
    async initiateFSCPayment(requestParameters: InitiateFSCPaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CreatePaymentResponseData> {
        const response = await this.initiateFSCPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
